// extracted by mini-css-extract-plugin
module.exports = {"toastWidth":"Toast_toastWidth__3l0Pa","fadeToast":"Toast_fadeToast__1BNt-","fade":"Toast_fade__2hjJQ"};